import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFLookupCashRegister } from "../../../../Shared/NewForms/NFLookupCashRegister";
import { useTranslation } from "react-i18next";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { useFormContext } from "react-hook-form";

const IncomingCashsLoanRepaymentDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Row>
      <Col sm={6}>
        <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} required />
      </Col>
      <Col sm={6}>
        <NFLookupCashRegister fieldName="senderCashRegisterId" title={t("SenderCashRegister")} required />
      </Col>
    </Row>
  );
};

export default IncomingCashsLoanRepaymentDetail;
